// Ids are a contract with the tags Product builds in Pendo Designer: renaming or removing one
// silently breaks that tag. Repeated elements share one id; `data-pendo-item` carries the type.
export const PENDO_ID = Object.freeze({
  NAV_LOGO: "nav-logo",
  NAV_HELP: "nav-help",
  NAV_ACCOUNT_MENU: "nav-account-menu",
  NAV_LOGOUT: "nav-logout",

  SEARCH_SUBMIT: "search-submit",
  SEARCH_CLEAR: "search-clear",
  SEARCH_INPUT: "search-input",
  SEARCH_TOKEN: "search-token",
  SEARCH_CATALOG_LINK: "search-catalog-link",
  SEARCH_TEMPLATE_CARD: "search-template-card",
  SEARCH_TEMPLATES_SHOW_MORE: "search-templates-show-more",

  PALETTE_TERM_ROW: "palette-term-row",
  PALETTE_RUN_LITERAL: "palette-run-literal",
  PALETTE_RETRY_PLACES: "palette-retry-places",
  PALETTE_CATALOG_LINK: "palette-catalog-link",
  PALETTE_REMOVE_SELECTED: "palette-remove-selected",

  BAND_AGGREGATION: "band-aggregation",
  BAND_ALL: "band-all",
  BAND_PRESET: "band-preset",
  BAND_CUSTOM_APPLY: "band-custom-apply",

  CATALOG_TAB: "catalog-tab",
  CATALOG_CLOSE: "catalog-close",
  CATALOG_APPLY: "catalog-apply",
  CATALOG_BACK: "catalog-back",
  CATALOG_CATEGORY: "catalog-category",
  CATALOG_FEATURE: "catalog-feature",
  CATALOG_METRIC_CARD: "catalog-metric-card",
  CATALOG_METRIC_OPTION: "catalog-metric-option",
  CATALOG_SELECTED_TAG: "catalog-selected-tag",
  CATALOG_PLACE_LEVEL_SELECT: "catalog-place-level-select",
  CATALOG_ADD_LOCATION: "catalog-add-location",

  SAVED_SEARCH_LINK: "saved-search-link",
  SAVED_SEARCH_MENU: "saved-search-menu",
  SAVED_SEARCH_RENAME: "saved-search-rename",
  SAVED_SEARCH_DELETE: "saved-search-delete",
  SAVED_SEARCH_RENAME_SAVE: "saved-search-rename-save",
  SAVED_SEARCH_RENAME_CANCEL: "saved-search-rename-cancel",
  SAVED_SEARCH_DELETE_CONFIRM: "saved-search-delete-confirm",
  SAVED_SEARCH_DELETE_CANCEL: "saved-search-delete-cancel",

  SAVE_MODAL_SAVE: "save-modal-save",
  SAVE_MODAL_CANCEL: "save-modal-cancel",

  RESULTS_VIEW_TOGGLE: "results-view-toggle",
  RESULTS_PARAMETERS_TOGGLE: "results-parameters-toggle",
  RESULTS_AGGREGATION_TOGGLE: "results-aggregation-toggle",
  RESULTS_PARAMETERS_LINK: "results-parameters-link",
  RESULTS_MORE_ACTIONS: "results-more-actions",
  RESULTS_EXPORT: "results-export",
  RESULTS_ROW: "results-row",
  RESULTS_ROW_LINK: "results-row-link",
  RESULTS_COLUMN_HEADER: "results-column-header",
  RESULTS_SAVE_SEARCH: "results-save-search",
  RESULTS_SAVE_SEARCH_EMPTY: "results-save-search-empty",

  MAP_GEO_LEVEL_SELECT: "map-geo-level-select",
  MAP_METRIC_SELECT: "map-metric-select",
  MAP_CANVAS: "map-canvas",

  PROFILE_BACK_TO_RESULTS: "profile-back-to-results",
  PROFILE_COMPARE_OPEN: "profile-compare-open",
  PROFILE_COMPARE_MENU: "profile-compare-menu",
  PROFILE_COMPARE_CHANGE: "profile-compare-change",
  PROFILE_COMPARE_REMOVE: "profile-compare-remove",
  PROFILE_TAB: "profile-tab",
  PROFILE_FORMAT_TOGGLE: "profile-format-toggle",
  PROFILE_CHART_COPY: "profile-chart-copy",
  PROFILE_CHART_DOWNLOAD: "profile-chart-download",
  PROFILE_FILTER_PILL: "profile-filter-pill",
  PROFILE_PICKER_OPTION: "profile-picker-option",
  PROFILE_SCORE_SELECT: "profile-score-select",
  PROFILE_DEMOGRAPHIC_SELECT: "profile-demographic-select",
  PROFILE_EARLY_VOTE_TYPE_SELECT: "profile-early-vote-type-select",
  PROFILE_EARLY_VOTE_COMPARISON_SELECT: "profile-early-vote-comparison-select",

  EARLY_VOTE_NAV_HOME: "early-vote-nav-home",
  EARLY_VOTE_NAV_LINK: "early-vote-nav-link",
});

export const PENDO_EVENT = Object.freeze({
  SEARCH_SUBMITTED: "search_submitted",
  SEARCH_TEMPLATE_APPLIED: "search_template_applied",
  QUERY_ITEM_ADDED: "query_item_added",
  QUERY_ITEM_REMOVED: "query_item_removed",
  QUERY_BAND_SELECTED: "query_band_selected",
  RESULTS_VIEW_TOGGLED: "results_view_toggled",
  RESULTS_COLUMN_SORTED: "results_column_sorted",
  RESULTS_MAP_OPTION_CHANGED: "results_map_option_changed",
  RESULTS_GEO_CLICKED: "results_geo_clicked",
  RESULTS_PROFILE_OPENED: "results_profile_opened",
  PROFILE_TAB_SELECTED: "profile_tab_selected",
  PROFILE_COMPARE_COMPLETED: "profile_compare_completed",
  PROFILE_FILTER_TOGGLED: "profile_filter_toggled",
  PROFILE_SCORE_SELECTED: "profile_score_selected",
  PROFILE_DEMOGRAPHIC_SELECTED: "profile_demographic_selected",
  PROFILE_EARLY_VOTE_OPTION_SELECTED: "profile_early_vote_option_selected",
});

// `item` is an enum (never user content), so it is safe to send to Pendo.
export const pendoId = (id, item) => ({
  "data-pendo-id": id,
  ...(item ? { "data-pendo-item": item } : {}),
});
